import React from 'react';
import { AlertTriangle, Droplets, ShieldCheck } from 'lucide-react';

const defaultStats = [
  {
    icon: AlertTriangle,
    stat: '80%',
    label: 'of diseases in India',
    detail: 'are caused by contaminated drinking water supply',
    color: 'text-red-500',
    bg: 'bg-red-50',
    border: 'border-red-100',
    iconBg: 'bg-red-100'
  },
  {
    icon: Droplets,
    stat: '1500+',
    label: 'mg/L avg TDS',
    detail: 'in Jaipur tap water (safe limit is just 500 mg/L)',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    border: 'border-amber-100',
    iconBg: 'bg-amber-100'
  },
  {
    icon: ShieldCheck,
    stat: '99.9%',
    label: 'bacteria & viruses',
    detail: 'eliminated by RO purification technology',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100',
    iconBg: 'bg-emerald-100'
  }
];

const WaterAwareness = ({ cms }) => {
  const d = cms || {};
  const title = d.title || 'Why Pure Water Matters';
  const subtitle = d.subtitle || 'The Water Reality';
  const cmsItems = d.items || d.stats;

  const displayStats = cmsItems && cmsItems.length > 0
    ? cmsItems.map((item, i) => ({
        ...defaultStats[i] || defaultStats[0],
        stat: item.value || item.stat || defaultStats[i]?.stat || '',
        label: item.label || defaultStats[i]?.label || '',
        detail: item.detail || item.description || defaultStats[i]?.detail || '',
      }))
    : defaultStats;

  return (
  <section className="py-16 md:py-24 bg-white reveal-on-scroll" data-testid="water-awareness-section">
    <div className="container mx-auto px-4">
      <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
        <p className="text-xs sm:text-sm font-semibold text-blue-700 uppercase tracking-wider mb-3">{subtitle}</p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
          {title.includes('Pure Water') ? <>Why Pure Water <span className="text-blue-700">Matters</span></> : title}
        </h2>
      </div>

      <div className="grid sm:grid-cols-3 gap-5 sm:gap-6 max-w-4xl mx-auto">
        {displayStats.map((item, i) => (
          <div
            key={i}
            className={`${item.bg} border ${item.border} rounded-2xl p-5 sm:p-7 text-center hover:shadow-lg transition-shadow`}
            data-testid={`water-stat-${i}`}
          >
            <div className={`inline-flex p-2.5 rounded-xl ${item.iconBg} mb-4`}>
              <item.icon className={item.color} size={24} />
            </div>
            <div className={`text-3xl sm:text-4xl md:text-5xl font-bold ${item.color} mb-1.5`}>{item.stat}</div>
            <div className="text-sm sm:text-base font-semibold text-gray-900 mb-1">{item.label}</div>
            <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">{item.detail}</p>
          </div>
        ))}
      </div>

      <p className="text-center text-gray-400 mt-8 max-w-md mx-auto text-xs sm:text-sm">
        {d.footer_text || "Don't compromise on your family's health. Invest in quality water purification today."}
      </p>
    </div>
  </section>
  );
};

export default WaterAwareness;
